import React from 'react';
import ReactDOM from 'react-dom';
import { setConfiguration } from 'react-grid-system';
import { IconContext } from 'react-icons';
import { Provider } from 'react-redux';

import { ErrorBoundary } from '@sentry/react';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'styled-components';
import { Theme } from 'theme/theme';

import { EmergencyMessageProvider } from 'components/EmergencyMessage/emergencyMessageContext';
import { GlobalBottomSheetProvider } from 'components/GlobalBottomSheet/globalBottomSheetContext';
import { ToastProvider } from 'components/Toast/toastContext';
import Version from 'components/Version';
import VersionTags from 'components/VersionTags';
import { SelectionOriginProvider } from 'hooks/useSelectionOrigin/SelectionOriginContext';
import Router from 'routers/router';

import * as serviceWorker from './serviceWorker';
import { store, persistor } from './store';
import { GlobalStyle } from './styles';
import ModalSessionToken from './components/ModalSessionToken'; // Importa tu modal

import 'i18n';
import 'setupYup';
import 'setupSentry';
import 'utils/prototypes';
import 'utils/polyfills';
import 'utils/currencyInputFix';
import { Container } from '@material-ui/core';
import { Desktop } from 'components/Responsive';
import ApplicationOverlayContentSessionToken from 'components/ApplicationLayout/ApplicationOverlayContentSessionToken';

setConfiguration({ gutterWidth: 8, gridColumns: 6 });
const handleCloseModal = () => {
  console.log('aqui')
};



ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={Theme}>
          <GlobalStyle />
          <IconContext.Provider value={{ className: 'icons' }}>
            <GlobalBottomSheetProvider>
              <EmergencyMessageProvider>
                <ToastProvider>
                  <SelectionOriginProvider>
                    <ApplicationOverlayContentSessionToken
                      sessionToken={true}
                      width={600}
                      onClose={handleCloseModal}
                      testId="flight-details"
                      zIndex={999}
                    >
                      <Container>
                        <Desktop>
                          <ModalSessionToken />
                        </Desktop>
                      </Container>
                    </ApplicationOverlayContentSessionToken>
                    <Router />
                    <Version />
                    <VersionTags />
                  </SelectionOriginProvider>
                </ToastProvider>
              </EmergencyMessageProvider>
            </GlobalBottomSheetProvider>
          </IconContext.Provider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root'),
);


serviceWorker.unregister();
